<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'Setting',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-settings-3-line',
  color: 'error',
  title: 'Pengaturan SMTP & AI Provider',
  description: 'Mengonfigurasi email pengirim notifikasi dan provider AI yang dipakai.',
  purpose: 'Panduan mengatur integrasi SMTP (email) dan AI Provider dari satu halaman terpusat.',
  concept: [
    {
      icon: 'ri-mail-line',
      title: 'SMTP untuk Notifikasi Email',
      text: 'Reminder dan notifikasi tertentu dikirim lewat email — SMTP inilah "mesin pengirim" email itu. Tanpa SMTP dikonfigurasi, notifikasi dalam aplikasi tetap jalan, tapi email tidak terkirim.',
    },
    {
      icon: 'ri-key-line',
      title: 'API Key Selalu Tampil Tertutup Setelah Tersimpan',
      text: 'Setelah Anda simpan password SMTP atau API Key AI, field itu akan selalu tampil sebagai titik-titik (••••••••) — ini bukan bug, sistem sengaja tidak pernah menampilkan kembali nilai aslinya demi keamanan.',
    },
  ],
  steps: [
    { title: 'Buka menu Pengaturan, pilih tab "SMTP"', detail: 'Isi Host, Port, Username, Password, dan alamat pengirim.' },
    { title: 'Klik "Test Koneksi" sebelum menyimpan', detail: 'Memastikan pengaturan benar sebelum dipakai untuk kirim email sungguhan.' },
    { title: 'Klik "Simpan"', detail: 'Pengaturan langsung aktif tanpa perlu restart aplikasi.' },
    { title: 'Pindah ke tab "AI Provider" untuk mengatur AI', detail: 'Pilih provider (OpenAI/Claude/Gemini/Ollama), isi API Key dan model, klik "Test Koneksi" lalu "Simpan".' },
  ],
  tips: [
    'Kalau ingin mengubah password/API Key, ketik nilai baru langsung — kalau field dibiarkan berisi titik-titik tanpa diubah, nilai lama tetap dipakai (tidak ada risiko tertimpa kosong secara tidak sengaja).',
  ],
  faq: [
    { q: 'Apakah saya bisa menghapus API Key yang sudah tersimpan?', a: 'Belum ada tombol khusus untuk mengosongkan API Key di versi ini — gantikan dengan API Key baru kalau ingin memperbarui.' },
  ],
  related: [
    { title: 'Chat AI, Draft SOP/CAPA, Analisis IKP', sub: 'Memakai AI Assistant setelah provider dikonfigurasi', icon: 'ri-sparkling-2-line', color: 'purple', to: { name: 'help-ai-assistant-chat-ai' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
